import axiosInstance from "../config/axiosInterceptor";

export async function getNodeConfigurations() {
  return await axiosInstance.get("/api/NodeConfiguration");
}

export async function getNodeConfigurationById(id) {
  return await axiosInstance.get(`/api/NodeConfiguration/${id}`);
}

export async function getNodeConfigurationsByNodeId(nodeId) {
  return await axiosInstance.get(`/api/NodeConfiguration/ByNodeId/${nodeId}`);
}

export async function createNodeConfiguration(nodeConfigurationData) {
  return await axiosInstance.post("/api/NodeConfiguration", nodeConfigurationData);
}

export async function updateNodeConfiguration(nodeConfigurationData) {
  return await axiosInstance.put("/api/NodeConfiguration", nodeConfigurationData);
}

export async function deleteNodeConfiguration(id) {
  return await axiosInstance.delete(`/api/NodeConfiguration/${id}`);
}
